import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import SvgIcon from './SvgIcon.js';
import '@babel/runtime/helpers/esm/objectWithoutProperties';
import 'react-desc';
import '@elliemae/ds-classnames';

var createIcon = (function (_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      paths = _ref.paths,
      height = _ref.height,
      width = _ref.width;
  return function (rest) {
    return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, rest, containerProps, {
      paths: paths,
      viewBox: "0 0 ".concat(width, " ").concat(height)
    }));
  };
});

export default createIcon;
//# sourceMappingURL=createIcon.js.map
